<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 row pt-3 pr-4 layout pb-2>
        <v-spacer></v-spacer>
        <v-icon small color="blue darken-1" class="pb-1 pr-2">send</v-icon>
        <span class="mr-3">Enviado</span>
        <v-icon small color="success" class="pb-1 pr-2">check_circle</v-icon>
        <span class="mr-3">Aprovado</span>
        <v-icon small color="primary" class="pb-1 pr-2">warning</v-icon>
        <span class="mr-3">Não informado</span>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="revision_dates_computed"
          :rows-per-page-items="[15, 20, 30]"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.reference_month | moment("MM/YYYY")}}</td>
            <td class="text-xs-left">
              <div v-if="props.item.closedMonth">
                <v-icon small color="blue darken-1" class="pr-2 pl-1 pl-1">send</v-icon>
                {{ props.item.analyze_sindication_send}}
              </div>
              <v-edit-dialog
                v-if="!props.item.closedMonth && !viewForm"
                :return-value.sync="props.item.analyze_sindication_send"
                large
                lazy
                light
                @save="save('analyze_sindication_send', props.item, true)"
                save-text="Salvar"
                @cancel="cancel"
                cancel-text="Cancelar"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.analyze_sindication_send">
                  <v-icon small color="blue darken-1" class="pr-2 pl-1 pl-1">send</v-icon>
                  {{ props.item.analyze_sindication_send}}
                </div>
                <div v-if="!props.item.analyze_sindication_send" class="text-xs-center">
                  <v-icon color="primary" class="pb-1 pr-2 pl-5">warning</v-icon>
                </div>
                <template v-slot:input>
                  <v-text-field
                    class="mt-4"
                    clearable
                    v-model="props.item.analyze_sindication_send"
                    mask="##/##/####"
                    return-masked-value
                    label="Data"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-left">
              <div v-if="props.item.closedMonth">
                <v-icon small color="success" class="pr-2 pl-1">check_circle</v-icon>
                {{ props.item.analyze_sindication_approve }}
              </div>
              <v-edit-dialog
                v-if="!props.item.closedMonth && !viewForm"
                :return-value.sync="props.item.analyze_sindication_approve"
                large
                lazy
                light
                @save="save('analyze_sindication_approve',props.item, true)"
                save-text="Salvar"
                @cancel="cancel"
                cancel-text="Cancelar"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.analyze_sindication_approve">
                  <v-icon small color="success" class="pr-2 pl-1">check_circle</v-icon>
                  {{ props.item.analyze_sindication_approve }}
                </div>
                <div v-if="!props.item.analyze_sindication_approve" class="text-xs-center">
                  <v-icon color="primary" class="pb-1 pr-2 pl-5">warning</v-icon>
                </div>
                <template v-slot:input>
                  <v-text-field
                    class="mt-4"
                    clearable
                    v-model="props.item.analyze_sindication_approve"
                    mask="##/##/####"
                    return-masked-value
                    label="Data"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-left">
              <div v-if="props.item.closedMonth">
                <v-icon small color="blue darken-1" class="pr-2 pl-1">send</v-icon>
                {{ props.item.analyze_manager_send }}
              </div>
              <v-edit-dialog
                v-if="!props.item.closedMonth && !viewForm"
                :return-value.sync="props.item.analyze_manager_send"
                large
                lazy
                light
                @save="save('analyze_manager_send',props.item, true)"
                save-text="Salvar"
                @cancel="cancel"
                cancel-text="Cancelar"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.analyze_manager_send">
                  <v-icon small color="blue darken-1" class="pr-2 pl-1">send</v-icon>
                  {{ props.item.analyze_manager_send }}
                </div>
                <div v-if="!props.item.analyze_manager_send" class="text-xs-center">
                  <v-icon color="primary" class="pb-1 pr-2 pl-5">warning</v-icon>
                </div>
                <template v-slot:input>
                  <v-text-field
                    class="mt-4"
                    clearable
                    v-model="props.item.analyze_manager_send"
                    mask="##/##/####"
                    return-masked-value
                    label="Data"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-left">
              <div v-if="props.item.closedMonth">
                <v-icon small color="success" class="pr-2 pl-1">check_circle</v-icon>
                {{ props.item.completed_by_sindication }}
              </div>
              <v-edit-dialog
                v-if="!props.item.closedMonth && !viewForm"
                :return-value.sync="props.item.completed_by_sindication"
                large
                lazy
                light
                @save="save('completed_by_sindication',props.item, true)"
                save-text="Salvar"
                @cancel="cancel"
                cancel-text="Cancelar"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.completed_by_sindication">
                  <v-icon small color="success" class="pr-2 pl-1">check_circle</v-icon>
                  {{ props.item.completed_by_sindication }}
                </div>
                <div v-if="!props.item.completed_by_sindication" class="text-xs-center">
                  <v-icon color="primary" class="pb-1 pr-2 pl-5">warning</v-icon>
                </div>
                <template v-slot:input>
                  <div class="mt-2 text-xs-left">
                    <span
                      class="caption"
                      v-html="'<b>Obs: </b></b>Quando todas as datas estiverem <br/>preenchidas não será mais possivel editalas.'"
                    ></span>
                  </div>
                  <v-text-field
                    class="mt-2"
                    clearable
                    v-model="props.item.completed_by_sindication"
                    mask="##/##/####"
                    return-masked-value
                    label="Data"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-center">
              <v-icon v-if="props.item.audited" color="success" class>check_circle</v-icon>
              <v-icon
                v-if="!props.item.audited"
                @click="finalizePrestation(props.item)"
                class
                :disabled="viewForm"
              >check_box_outline_blank</v-icon>
              <!-- <v-checkbox
                v-if="!props.item.closedMonth"
                hide-details
                
                v-model="props.item.closedMonth"
              ></v-checkbox>-->
            </td>
            <td class="text-xs-left">
              <!-- <div v-if="props.item.closedMonth">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ `${(props.item.observation && props.item.observation.length >= 31)
                      ? props.item.observation.substring(0,30)+'...'
                      : (props.item.observation ? props.item.observation : '')}` }}
                    </span>
                  </template>
                  <span>{{props.item.observation}}</span>
                </v-tooltip>
              </div>-->
              <!-- v-if="!props.item.closedMonth" -->
              <v-edit-dialog
                v-if="!viewForm"
                :return-value.sync="props.item.observation"
                large
                lazy
                light
                @save="save('observation', props.item, false)"
                save-text="Salvar"
                @cancel="cancel"
                cancel-text="Cancelar"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.observation">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                      >{{ `${props.item.observation.length >= 31 ? props.item.observation.substring(0,30)+'...' : props.item.observation}` }}</span>
                    </template>
                    <span>{{props.item.observation}}</span>
                  </v-tooltip>
                </div>
                <div v-if="!props.item.observation" class="text-xs-center">
                  <v-icon small color class="pb-1 pr-2 pl-4">edit</v-icon>
                </div>
                <template v-slot:input>
                  <v-text-field
                    class="mt-4"
                    clearable
                    v-model="props.item.observation"
                    return-masked-value
                    label="Observação"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-center">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    @click="downloadFile(props.item.file_month)"
                    v-if="props.item.file_month"
                    color="success"
                    class
                  >cloud_download</v-icon>
                </template>
                <span>{{props.item.file_month_name}}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    @click="confirmRemoveFileLine(props.item)"
                    v-if="props.item.file_month"
                    color="primary"
                    class="microIcon"
                  >clear</v-icon>
                </template>
                <span>Remover arquivo</span>
              </v-tooltip>
              <v-icon
                @click="upload(props.item)"
                v-if="!props.item.file_month && !viewForm"
                color="blue darken-3"
                class
              >unarchive</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import * as moment from "moment";

export default {
  name: "RevisionDatesGrid",

  props: {
    revision_dates: Array,
    uploadDialog: Function,
    viewForm: Boolean
  },

  data() {
    return {
      date_limit: "",
      date_limit_menu: false,
      headers: [
        {
          text: "Mês de referência",
          align: "center",
          sortable: true,
          value: "name",
        },
        {
          text: "Recebido pela sindicância",
          value: "analyze_sindication_send",
          sortable: false,
          align: "left",
        },
        {
          text: "Analisado pela sindicância",
          value: "analyze_sindication_approve",
          sortable: false,
          align: "left",
        },
        {
          text: "Retornado pela gerenciadora",
          value: "analyze_manager_send",
          sortable: false,
          align: "left",
        },
        {
          text: "Finalizado pela sindicância",
          value: "completed_by_sindication",
          sortable: false,
          align: "left",
        },
        {
          text: "Auditado",
          value: "audited",
          sortable: false,
          align: "center",
        },
        { text: "Observações", value: "observation", sortable: false },
        {
          text: "Arquivo",
          align: "center",
          value: "file_month",
          sortable: false,
        },
      ],
    };
  },

  computed: {
    revision_dates_computed: function () {
      if (this.revision_dates) {
        return this.revision_dates;
      } else {
        return [];
      }
    },
  },

  methods: {
    confirmRemoveFileLine(data) {
      let obj = {
        message: `Você deseja apagar o arquivo ${data.file_month_name}?`,
        title: "Excluir arquivo",
        callback: (_) => {
          this.removeFileLine(data);
        },
        type: "warning",
        btConfirm: { name: "Sim", show: true },
        btCancel: { name: "Não", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", obj);
    },

    removeFileLine(data) {
      //accountability_folder/destroyFile/
      let obj = {
        url: "/api/accountability_folder/destroyFile/" + data.id,
        query: "",
        method: "delete",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response) {
          return;
        }
        data.file_month = "";
        data.file_month_name = "";
        let opts = {
          message: `Arquivo removido com sucesso`,
          type: "success",
        };
        this.$store.commit("showAlert", opts);
      });
    },

    downloadFile(path) {
      // console.log(path);
      // return;
      let baseURL =
        process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_API_URL
          : process.env.VUE_APP_API_URL_DEV;

      baseURL;
      window.open(`${baseURL}/storage/${path}`);
    },

    confirmFinalizePrestation(audit) {
      let countNull = 0;
      Object.keys(audit).forEach((key) => {
        if (
          key != "observation" &&
          key != "file_month" &&
          audit[key] === null
        ) {
          countNull++;
        }
      });
      if (countNull) {
        let obj = {
          message:
            "O processo não pode ser concluído, pois ainda faltam algumas etapas.",
          title: "Processo incompleto",
          type: "warning",
          btConfirm: { name: "Sim", show: false },
          btCancel: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", obj);
        return;
      }
      //return;
      let obj = {
        message: `Você deseja encerrar o processo de prestação de contas de ${moment(
          audit.reference_month
        ).format("MM/YYYY")}?`,
        title: "Encerrar",
        callback: (_) => {
          this.finalizePrestation(audit);
        },
        type: "warning",
        btConfirm: { name: "Sim", show: true },
        btCancel: { name: "Não", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", obj);
    },

    finalizePrestation(value) {
      if (
        !value.analyze_manager_send ||
        !value.analyze_sindication_approve ||
        !value.analyze_sindication_send ||
        !value.completed_by_sindication
      ) {
        let obj = {
          message:
            "A auditoria só pode acontecer após todas as datas estarem preenchidas.",
          title: "Ops!",
          callback: (_) => {},
          type: "warning",
          btConfirm: { name: "Sim", show: false },
          btCancel: { name: "OK", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", obj);
        return;
      }
      let data = {
        reference_month: value.reference_month,
        accountabilities_id: value.accountabilities_id,
        id: value.id,
        audited: 1,
      };
      let obj = {
        url: "/api/accountability_folder/update",
        query: data,
        method: "put",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response) {
          return;
        }
        value.audited = true;
        let opts = {
          message: `Prestação de contas encerrada`,
          type: "Processo finalizado",
        };
        this.$store.commit("showAlert", opts);
      });
    },

    upload(data) {
      this.uploadDialog("upLoad", "", data);
      return;
    },

    save(field, value, fieldDate) {
      if (fieldDate) {
        let arrs = value[field].split("/");
        let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`;
        value[field] = date;
      }
      let data = {
        reference_month: value.reference_month,
        accountabilities_id: value.accountabilities_id,
        id: value.id,
      };
      data[field] = value[field];

      // console.log(value);
      // return;
      let obj = {
        returnError: true,
        url: "/api/accountability_folder/update",
        query: data,
        method: "put",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response) {
          return;
        }

        if (response.response && response.response.status >= 400) {
          let ind = this.revision_dates_computed.findIndex(
            (folder) => folder.id == value.id
          );

          let obj = {
            message: `${
              response.response.data.message
                ? response.response.data.message
                : response.response.data
            }`,
            title: "Ops!",
            callback: (_) => {
              this.revision_dates_computed[ind][field] = "";
            },
            type: "error",
            btConfirm: { name: "ok", show: true },
            btCancel: { name: "Não", show: false },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", obj);
          //this.revision_dates_computed.splice(ind, 1, response.data);
          return;
        }
        if (
          response.data.analyze_manager_send &&
          response.data.analyze_sindication_approve &&
          response.data.analyze_sindication_send &&
          response.data.completed_by_sindication
        ) {
          response.data.closedMonth = true;
          let ind = this.revision_dates_computed.findIndex(
            (folder) => folder.id == response.data.id
          );

          response.data.analyze_manager_send = moment(
            response.data.analyze_manager_send
          ).format("DD/MM/YYYY");

          response.data.analyze_sindication_approve = moment(
            response.data.analyze_sindication_approve
          ).format("DD/MM/YYYY");

          response.data.analyze_sindication_send = moment(
            response.data.analyze_sindication_send
          ).format("DD/MM/YYYY");

          response.data.completed_by_sindication = moment(
            response.data.completed_by_sindication
          ).format("DD/MM/YYYY");

          this.revision_dates_computed.splice(ind, 1, response.data);
          //this.revision_dates_computed[ind].closedMonth = true;
        }
        //console.log(response.data);
      });
    },

    cancel() {},
    open() {},
    close() {
      //console.log("Dialog closed");
    },
  },
};
</script>

<style>
.microIcon {
  font-size: 10px !important;
  margin-bottom: 15px;
}
</style>